const getRandomInt = (min: number, max: number) => min + Math.round(Math.random() * (max - min));

const UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LOWER = 'abcdefghijklmnopqrstuvwxyz';
const NUMBER = '0123456789';
const ALNUM = `${UPPER}${LOWER}${NUMBER}`;

const getRandomChar = (charSource: string) =>
  charSource.charAt(getRandomInt(0, charSource.length - 1));

const getRandomString = (charSource = ALNUM, length = 17): string =>
  new Array(length)
    .fill(null)
    .map(() => getRandomChar(charSource))
    .join('');

export { getRandomString };
